module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_3-e98404a1b7c91a1b78bf2062943e77df.jpg";